import { render, staticRenderFns } from "./PubEvents.vue?vue&type=template&id=3db2d0ff&scoped=true&"
import script from "./PubEvents.vue?vue&type=script&lang=js&"
export * from "./PubEvents.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PubEvents.vue?vue&type=style&index=1&id=3db2d0ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db2d0ff",
  null
  
)

export default component.exports